import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import {
  Button,
  Label,
} from '../../common';

export default function PaymentTypes({
  paymentvalues,
  errors,
  onChange,
  paymentTypes,
  items,
}) {
  const { properties } = items;

  // Convert paymentTypes to match paymentvalues structure for React Select
  const convertedPaymentTypes = paymentTypes.map((type) => ({
    label: type.label,
    value: type.value,
    type: type.value,
  }));

  return (
    <div className="payment-methods">
      <div className="payment-billing-containers">
        {/* <div className="title-header">
          <div className="label">
            {properties?.description || 'PAYMENT METHOD'}
          </div>
        </div> */}
        <Select
          placeholder="Type"
          name="type"
          classNamePrefix="react-select"
          className="react-select-container"
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          options={convertedPaymentTypes.filter(
            (opt) => !paymentvalues.some((val) => val.type === opt.type),
          )}
          isMulti
          defaultValue={[]}
          noOptionsMessage={() => null}
          value={paymentvalues}
          onChange={(selectedOptions) => {
            onChange({ target: { name: 'paymentTypes', value: selectedOptions || [] } });
          }}
        />
        <Label type="error">{errors.paymentTypes}</Label>
      </div>
    </div>
  );
}

PaymentTypes.propTypes = {
  paymentvalues: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
    discount: PropTypes.number,
    processing_fee: PropTypes.number,
  })),
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
  paymentTypes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  })),
  items: PropTypes.shape({
    properties: PropTypes.shape({
      description: PropTypes.string,
    }),
  }),
};

PaymentTypes.defaultProps = {
  paymentvalues: [],
  errors: {},
  paymentTypes: [],
  items: { properties: {} },
};
